import React from "react";
import { Outlet } from "react-router-dom";

function userSurvery() {
    return (
        <div>
            <Outlet />
        </div>
    );
}

export default userSurvery;
